import { FlowContainer } from '@labb/dx-engine';
import { createContext, useContext, type MutableRefObject } from 'react';

type FlowContainerContextValue = {
  container: FlowContainer | null;
  isNavigatingBack: boolean;
  isNavigatingBackRef: MutableRefObject<boolean>;
};

const defaultNavigatingBackRef: MutableRefObject<boolean> = { current: false };

export const FlowContainerContext = createContext<FlowContainerContextValue>({
  container: null,
  isNavigatingBack: false,
  isNavigatingBackRef: defaultNavigatingBackRef,
});

export function useFlowContainer(): FlowContainer | null {
  return useContext(FlowContainerContext).container;
}

export function useIsNavigatingBack(): boolean {
  const { isNavigatingBack, isNavigatingBackRef } = useContext(FlowContainerContext);
  return isNavigatingBack || isNavigatingBackRef.current;
}

export function useIsNavigatingBackRef(): MutableRefObject<boolean> {
  return useContext(FlowContainerContext).isNavigatingBackRef;
}
